import { Provider } from '@angular/core';
import { RotorCompareService, RotorCompareState } from './rotor-compare.service';
import { RotorSelectInfoService } from './rotor-select-info.service';
import { RotorSearchService, RotorSearchResult, SearchState } from './rotor-search.service';
import { SettingsService } from './settings.service';
import { DownloadService } from './download.service';
import { LogoValidationService } from './logo-validation.service';
import { FilterService } from './filter.service';
import { ReportTemplateService } from './report-template.service';
import { StorageService } from '@schenck/rotec-components';
import { Settings } from 'src/utils/interfaces/settings.interface';

export const serviceProviders: Provider[] = [
  RotorSearchService,
  RotorSelectInfoService,
  RotorCompareService,
  SettingsService,
  DownloadService,
  LogoValidationService,
  FilterService,
  ReportTemplateService,
  StorageService,
];

export {
  RotorCompareService,
  RotorSelectInfoService,
  RotorCompareState,
  RotorSearchService,
  RotorSearchResult,
  SearchState,
  SettingsService,
  Settings,
  DownloadService,
  LogoValidationService,
  FilterService,
  ReportTemplateService,
};
